



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIPROJECTSGETBYID= createAsyncThunk(
  "AlumniProjectGetById/AlumniProjectGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniProjectGetByIdSlice = createSlice({
  name: "AlumniProjectGetByIdSlice",
  initialState: {
    AlumniProjectGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniProjectGetById: (state) => {
        state.AlumniProjectGetById.loading = false
        state.AlumniProjectGetById.error = false
        state.AlumniProjectGetById.data = []
        state.AlumniProjectGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIPROJECTSGETBYID.fulfilled, (state, action) => {
      state.AlumniProjectGetById = {
        ...state.AlumniProjectGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPROJECTSGETBYID.pending, (state, action) => {
      state.AlumniProjectGetById = {
        ...state.AlumniProjectGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPROJECTSGETBYID.rejected, (state, action) => {
      state.AlumniProjectGetById = {
        ...state.AlumniProjectGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniProjectGetByIdAction = {
    ALUMNIPROJECTSGETBYID,
};

export { AlumniProjectGetByIdAction };
export default AlumniProjectGetByIdSlice.reducer;
export const {setInitialStateOfAlumniProjectGetById} = AlumniProjectGetByIdSlice.actions
